<template>
  <Modal
    v-model="_value"
    width="450"
    title="JT808添加终端参数"
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
    <div style="position:relative;">
      <span>主机号：{{_initData}}</span><br>
      <Select size="small" v-model="Jt808ParameterData.parametername" class="search-col" style="width: 180px;margin-right: 5px">
        <Option v-for="item in columns" :value="item.parametername" :key="item.id">{{ item.parametername }}</Option>
      </Select>
      <Input v-model="Jt808ParameterData.parameterdata" size="small" placeholder="终端参数" clearable  style="width: 180px"/>
    </div>
  </Modal>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'jt808-add-parameterdata-modal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    initData: null
  },
  data () {
    return {
      columns:[],

      Jt808ParameterData:{
        jt808deviceid:null,
        parametername:null,
        parameterdata:null,
      }
    }
  },
  methods: {
    ...mapActions([
      'Jt808DeviceServ_ResetAllReportInterval'
    ]),
    onOk () {
      store.dispatch('Jt808ParameterDataServ_AddObj',{
        params:this.Jt808ParameterData,
        urlparams:null
      }).then(()=>{
      this.$emit('refresh',true)

      }).catch(err=>{
        this.$Message.error(err)
      })

    },
    visibleChange(){
      this.Jt808ParameterData.jt808deviceid = this._initValue
      store.dispatch('Jt808ParameterServ_GetAll',{
        params:null,
        urlparams:null
      }).then(()=>{
        this.columns = store.getters.get_Jt808Parameter_GetAllResult
      }).catch(err=>{
        this.$Message.error(err)
      })
    },
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _initData: {
      get () {
        return this.initData
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },

  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<style scoped>

</style>
